module.exports = __webpack_public_path__ + "img/21ffa7b.png";